import classNames from 'classnames';
import type { MyIcon } from '@repo/icons';
import type { TestId } from '@repo/test-id';
import { DotSeparator } from '@repo/ui';

interface Props {
  icon: MyIcon;
  name: string;
  testId: TestId;
  onClick: () => void;
  showDot?: boolean;
  isActive?: boolean;
}

const baseClasses = 'flex max-w-60 flex-1 flex-col items-center border-t-2 cursor-pointer relative';
const spacingClasses = 'pt-2 pb-3';
const typographyClasses = 'text-sm font-medium';
const activeClasses = 'border-stroke-brand text-brand';
const inactiveClasses = 'text-body border-transparent';

export default function BottomBarButton({ icon: Icon, name, showDot, isActive, onClick }: Props) {
  const containerClasses = classNames(
    baseClasses,
    spacingClasses,
    typographyClasses,
    isActive ? activeClasses : inactiveClasses
  );

  return (
    <button className={containerClasses} type="button" onClick={onClick}>
      <Icon />
      {name}
      {showDot && <DotSeparator color="bg-danger" size="md" className="absolute top-2 ml-7" />}
    </button>
  );
}
